<template>
  <div class="skills-tools">
    <div class="skills-tools__box">
      <div class="skills-tools__item">
        <div class="main-form__box">
          <p>{{ $t("controls.skills") }}</p>
        </div>

        <div
          class="main-form__box main-checkbox main-checkbox_flex"
          v-for="item in skills"
          :key="item.id"
        >
          <input
            type="checkbox"
            :id="item.id"
            class="main-checkbox__input"
            v-model="activeSkills"
            :value="item.id"
            :disabled="!$guard('write', 'Masters')"
          />
          <label :for="item.id" class="main-checkbox__label">
            <svg
              width="14"
              height="11"
              viewBox="0 0 14 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.44912 8.6786L1.13019 5.25802L0 6.41462L4.44912 11L14 1.1566L12.8778 0L4.44912 8.6786Z"
                fill="#9BCD82"
              />
            </svg>
          </label>
          <label :for="item.id" class="main-checkbox__label-text">
            <span>{{ item.name }}</span>
          </label>
        </div>
      </div>

      <!-- <div class="skills-tools__item">
        <div class="main-form__box">
          <p>Tools</p>
        </div>

        <div
          class="main-form__box main-checkbox main-checkbox_flex"
          v-for="item in tools"
          :key="item.id"
        >
          <input
            type="checkbox"
            :id="item.id"
            class="main-checkbox__input"
            v-model="activeTools"
            :value="item.id"
          /><label :for="item.id" class="main-checkbox__label"
            ><svg
              width="14"
              height="11"
              viewBox="0 0 14 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.44912 8.6786L1.13019 5.25802L0 6.41462L4.44912 11L14 1.1566L12.8778 0L4.44912 8.6786Z"
                fill="#9BCD82"
              ></path></svg></label
          ><label :for="item.id" class="main-checkbox__label-text"
            ><span>{{ item.name }}</span></label
          >
        </div>
      </div>-->
    </div>

    <button
      class="main-button mt20"
      @click="saveTags"
      :disabled="!$guard('write', 'Masters')"
    >
      {{ $t("global.save") }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'tagsView',
    data() {
        return {
            activeSkills: [],
            // activeTools: []
        }
    },
    props: {
        dataUser: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            skills: 'skills/list',
            // tools: "tools/list"
        }),
        // isValid() {
        //   if (this.activeSkills.length === 0) return false;

    //   return true;
    // }
    },
    methods: {
        ...mapActions({
            addSkills: 'specialists/addSkills',
            // addTools: "specialists/addTools",
            getSkills: 'specialists/getSkills',
            // getTools: "specialists/getTools"
        }),
        async saveTags() {
            const response = await this.addSkills({
                id: this.dataUser.id,
                form: {
                    skills: this.activeSkills,
                },
            })

            const isOkey = response.status === 200 || response.status === 201
            if (!isOkey) return

            this.$notify({
                title: this.$t('notifications.tagAdded'),
                message: this.$t('notifications.tagAddedText'),
                duration: 3000,
            })
        },
        prepareData(data) {
            return data.map((item) => item.id)
        },
    },
    async created() {
        const skills = await this.getSkills(this.dataUser.id)
        // const tools = await this.getTools(this.dataUser.id);

        this.activeSkills = this.prepareData(skills.data.data)
    // this.activeTools = this.prepareData(tools.data.data);
    },
}
</script>
<style scoped lang="scss">
.skills-tools {
  &__box {
    display: flex;
  }

  &__item {
    width: 50%;
    color: var(--menu-text-color);
  }
}
</style>
